import React from "react";
import { useLanguage } from "./LanguageContext";
import "./LanguageSelector.css";

export default function LanguageSelector() {
  const { language, setLanguage, t } = useLanguage();

  return (
    <div className="aur-language-selector" role="group" aria-label={t("language")} data-testid="language-selector">
      <button type="button" onClick={() => setLanguage("en")} aria-pressed={language === "en"} data-testid="language-select-en">
        EN
      </button>
      <button type="button" onClick={() => setLanguage("es")} aria-pressed={language === "es"} data-testid="language-select-es">
        ES
      </button>
    </div>
  );
}